// extracted by mini-css-extract-plugin
module.exports = {"container":"single-cafes-restaurants-point-page_container__QetCH"};